'use client';

import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

interface RiskNoticeClientProps {
  slug: string;
  content: string;
  className?: string;
  textColor?: string;
  translations: {
    trigger: string;
    title: string;
  };
}

export default function RiskNoticeClient({ slug, content, className = '', textColor = 'gray', translations }: RiskNoticeClientProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  // Map textColor to valid Tailwind classes
  const getTextColorClass = (color: string) => {
    const colorMap: Record<string, string> = {
      'white': 'text-white', // White doesn't work with -800, use gray instead
      'gray': 'text-gray-800',
      'red': 'text-red-800',
      'blue': 'text-blue-800',
      'green': 'text-green-800',
      'yellow': 'text-yellow-800',
      'purple': 'text-purple-800',
      'pink': 'text-pink-800',
      'indigo': 'text-indigo-800',
      'orange': 'text-orange-800',
    };
    return colorMap[color] || 'text-white';
  };

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const modalContent = isOpen && (
    <div
      className="fixed inset-0 bg-black/50 z-[999999]"
      onClick={handleClose}
    >
      <div
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[90vw] max-w-[500px] bg-gray-900 text-white text-sm rounded-lg p-4 shadow-lg z-[1000000]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-start mb-3">
          <h3 className="text-sm font-semibold text-white">{translations.title}</h3>
          <button
            onClick={handleClose}
            className="text-white/60 hover:text-white text-lg leading-none cursor-pointer"
          >
            ×
          </button>
        </div>
        <div className="space-y-3" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );

  return (
    <>
      <div className={`relative ${className}`}>
        <button
          onClick={handleOpen}
          className="text-gray-800 text-xs underline decoration-dotted underline-offset-2 hover:text-gray-900 cursor-pointer bg-transparent border-none p-0 inline-block"
        >
          <span className={getTextColorClass(textColor)}>{translations.trigger}</span>
        </button>
      </div>
      
      {mounted && modalContent && createPortal(modalContent, document.body)}
    </>
  );
}
